<template>
  <div class="item-base">
    <div class="surround-box" v-if="ImageList.length<=8" >
      <img src="~assets/partner/logo.png" alt="">
      <div class="base-xian" :style="{width:420+'px',height:420+'px'}"></div>
      <div class="circle" v-for="(item,index) in ImageList" :key="index"
          :style="{transform:'rotateZ('+base_angel*(index+1)+'deg) translate('+200+'px) '}"
      >
        <div class="second"
             :style="{transform:'rotateZ('+(-base_angel*(index+1))+'deg)',backgroundColor:item.colour,
        }">
          <img :src="'http://'+item.logoUrl" alt="" class="img-list" >
        </div>
    </div>
    </div>
    <div class="surround-box" v-if="ImageList.length>8">
      <img src="~assets/partner/logo.png" alt="">
      <div class="base-xian UP" :style="{width:500+'px',height:500+'px'}"></div>
      <div class="circle " v-for="item in 8" :key="item+'sss'"
           :style="{transform:'rotateZ('+second_angel*(item)+'deg) translate('+260+'px) '}"
      >

         <div class="second" v-show="true"
              :style="{transform:'rotateZ('+(-second_angel*(item))+'deg)',backgroundColor:ImageList[item-1].colour,
        }">
           <img :src="'http://'+ImageList[item-1].logoUrl" alt="" class="img-list" >
         </div>

      </div>
      <div class="base-xian2 " :style="{width:820+'px',height:820+'px'}"></div>
      <div class="circle" v-for="item in (ImageList.length-8)" :key="item+'w'"
           :style="{transform:'rotateZ('+(third_angel*(item)+24)+'deg) translate('+420+'px) '}"
      >
        <div class="second"
             :style="{transform:'rotateZ('+(-third_angel*(item)-24)+'deg)',backgroundColor:ImageList[item+7].colour,
        }">
          <img :src="'http://'+ImageList[item+7].logoUrl" alt="" class="img-list" >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ImageShow",
    data(){
      return{
        first:null,
        second:null,
        base_angel:null,
        second_angel:45,
        third_angel:null,
      }
    },
    props:{
      ImageList:{}
    },
    watch:{
      'ImageList'(){
        this.base_angel=360/(this.ImageList.length)
        if(this.ImageList.length>8){
          this.third_angel= 360/(this.ImageList.length-8)
        }
      }
    },
    created() {

    },

  }
</script>

<style lang="less" scoped>
  .item-base{
    width: 74.5vw;
    height: 1200px;
    margin: 0 auto;
  }

  .surround-box{
    position: relative;
    /*<!--background: url("../../assets/partner/logo.png")center center / cover no-repeat;-->*/
    top:  30%;
    left: 35%;
    width:  200px;
    height:  200px;
    /*border-radius: 50%;*/
    /*padding: 10px;*/
    /*margin: 10px;*/
    z-index: 26;
    img{

      width: 320px;
      height: 320px;
    }
  }
  .circle{
    /* 这里一定要绝对定位，这样位置才能铺开来 */
    position: absolute;
    top: 80px;
    left: 90px;
    width: 138px;
    height:  138px;
    border-radius:  50%;
    line-height: 140px;
    z-index: 24;
    animation: UP 3s ease-in;
    .second{
      width: 100%;
      height: 100%;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s ease-in;
      .img-list{
        width: 140px;
        height: 50px;
        margin-top: 45px;
        /*object-fit: cover;*/
      }
    }
  }
  .base-xian{
    transform: rotateZ(10deg);
    position: absolute;
    top:  -54%;
    left: -45%;
    z-index: 20;
    border: 4px solid cornflowerblue;
    border-radius: 50%;
    animation: UP 3s ease-in;
  }
  .base-xian2{
    position: absolute;
    top:  -130%;
    left: -126%;
    z-index: 20;
    border: 4px solid cornflowerblue;
    border-radius: 50%;
    animation: UP 3s ease-in;
  }
  @-webkit-keyframes UP {
    from{

      opacity: 0.1;
    }
    to{
      opacity: 1;

    }
  }
</style>